// extracted by mini-css-extract-plugin
export default {"central_column":"text_meditations_styles_central_column__vFSlN"};